<script>
export default {
  render() {
    return (
      <el-select
        value={this.value}
        onInput={this.$listeners.input}
        clearable={this.clearable}
        attrs={this.$attrs}
        on={this.listeners}
      >
        {this.realOptions.map(({ label, value, disabled }) => {
          return (
            <el-option
              label={label}
              value={value}
              key={value}
              disabled={disabled}
            ></el-option>
          );
        })}
        {this.loading && (
          <div slot="empty" class="el-select-dropdown__empty">
            数据加载中...
          </div>
        )}
      </el-select>
    );
  },
  props: {
    value: {
      required: false,
      default: undefined,
    },
    options: {
      type: [Array, Function],
      required: false,
      default() {
        return [];
      },
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true,
    },
    listeners: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      realOptions: [],
      loading: false,
    };
  },
  watch: {
    options: {
      handler() {
        this.dealOptions();
      },
      immediate: true,
    },
  },
  methods: {
    dealOptions() {
      const options = this.options;
      const type = Object.prototype.toString.call(options);
      if (type === "[object Function]") {
        this.loading = true;
        options()
          .then((data) => {
            this.realOptions = this.dealOptionItem(data);
          })
          .finally(() => {
            this.loading = false;
          });
      } else if (type === "[object Array]") {
        this.realOptions = this.dealOptionItem(options);
      } else {
        this.realOptions = options;
      }
    },
    dealOptionItem(options) {
      return options.map((item) => {
        if (typeof item === "object") {
          const { label, text, value, ...fields } = item;
          return {
            label: label === undefined ? text : label,
            value: value,
            ...fields,
          };
        } else {
          return {
            label: item,
            value: item,
          };
        }
      });
    },
  },
};
</script>
